<template lang="pug">
  .qcw-comment-form(:class="{ 'email-mode': isEmailMode }"
    :style="isEmailMode ? 'padding: 18px 8px;' : 'padding: 8px 13px 13px; background: transparent; border: 0;'")

    div(v-if="!isEmailMode"
      style="border: 1px solid #C4C4C4; box-sizing: border-box; flex: 1; border-radius: 8px; background: #FFFFFF")
      .input-form(style="border: 0; padding: 16px 30px 10px 16px; margin: 0px;")
        textarea(placeholder="Send a message ..."
          @paste="handlePaste"
          @keyup="typingHandler($event)"
          @keydown.enter="trySubmitComment($event)"
          :style="textareaStyle"
          :class="{ 'qcw-text-warning': !isTwitterValid && showTwitterWordCount }"
          v-model="commentInput")
        span(
          v-if="showTwitterWordCount"
          :class="{ 'qcw-text-warning': !isTwitterValid }"
          style="font-size: 10px; position: absolute; top: 25px; right: 25px;")
          | {{ maxCount - commentInput.length }}
      div(style="display: flex; justify-content: space-between; padding: 3px 6px;")
        div(style="display: flex; gap: 3px;")
          i(class='qcw-icon')
            label
              input(class="uploader__input" name="file_all" type="file" @change="changeFile")
              icon(name="ic-new-file-attachment" :fill="core.UI.colors.formMessageIconColor")
          i(class='qcw-icon')
            label
              input(class="uploader__input" name="file_image" type="file" accept="image/*" multiple @change="handleImageData" ref="inputImage")
              icon(name="ic-new-image-attachment" :fill="core.UI.colors.formMessageIconColor")
          assistant-menu(v-if="isAssistant" :core="core" :menu="currentMenu" @assistant-menu="assistantMenuChange")
          div(id="predefined-button")
          div(id="agent-can-send-broadcast-inbox")

        i(@click="trySubmitComment($event)")
          icon(name="ic-new-send-message" :fill="sendBtnStatus" 
            :style="showTwitterWordCount ? checkInputIsTwitter : checkInputNotTwitter")

    //- email mode
    .container-form-msg(v-if="isEmailMode")
      .input-form(:class="{ 'email-mode-input': isEmailMode }")
        //- textarea(placeholder="Send a message ..."
        //-   @paste="handlePaste($event, true)"
        //-   @keyup="typingHandler($event)"
        //-   :style="textareaStyle"
        //-   :class="{ 'qcw-text-warning': !isTwitterValid && showTwitterWordCount }"
        //-   v-model="commentInput")
        WywygEditor(
          ref="emailEditor"
          @onchange="onchangeEmailForm"
          @ondeleteAttachment="deleteAttachment"
          :emailAttachments="emailAttachments")
      //- .container-email-attachments(v-if="isEmailMode && emailAttachments.length > 0")
      //-   span(
      //-     v-for="(attachment, i) in emailAttachments" :key="i"
      //-     class="email-attachments-item"
      //-   )
      //-     .name(:title="attachment.name") {{ attachment.name }} ({{ calculateSizeInMB(attachment.size) }})
      //-     i(class='qcw-icon' style="cursor: pointer" @click="deleteAttachment(i)")
      //-       icon(name="ic-close" fill="#EF7D7C" style="width: 15px; height: 15px;")

    .email-form-footer(v-if="isEmailMode")
      .container-email-button
        i(class='qcw-icon')
          label
            input(class="uploader__input" name="email_file_all" type="file" multiple @change="setEmailAttachment")
            icon(name="ic-file-attachment" :fill="core.UI.colors.formMessageIconColor")
        assistant-menu(v-if="isAssistant" :core="core" :menu="currentMenu" @assistant-menu="assistantMenuChangeOnEmail")
      .container-email-button
        i(
          v-if="cleanHtml(commentInput).length > 0 || emailAttachments.length > 0"
          class='qcw-icon' title="Clear all"
          style="cursor: pointer"
          @click="clearAllMessage()")
          icon(name="ic-trash" fill="#EF7D7C")
        button(
          class="send-button-email"
          :disabled="(cleanHtml(commentInput).length === 0 && emailAttachments.length === 0) || isSendingEmail"
          @click="sendEmailMessage") Send Now

    transition(name="backdrop")
      upload-image-form(
        v-if="imageData"
        :core="core"
        :data="imageData"
        @handle-close="handleImageData"
        @handle-upload="handleUploadData"
      )

    .qcw-upload-toast
      transition-group(name="fade")
        upload-image-toast(
          v-for="data in uploadData"
          :key="data.id"
          :core="core"
          :data="data"
          @handle-close="handleUploadData"
        )
</template>

<script>
import TurndownService from 'turndown';
import { uploadFile, uploadEmailAttachment } from '../lib/fileUploader';
import { scrollIntoLastElement, calculateSizeInMB } from '../lib/utils';
import Icon from './Icon';
import UploadImageForm from './UploadImageForm';
import UploadImageToast from './UploadImageToast';
import WywygEditor from './WywygEditor';
import AssistantMenu from './ai-assistant/menu';

export default {
  name: 'CommentForm',
  components: {
    Icon,
    UploadImageForm,
    UploadImageToast,
    WywygEditor,
    AssistantMenu,
  },
  props: [
    'core', 'repliedComment',
    'closeReplyHandler', 'showAttachmentForm',
    'toggleAttachmentForm', 'setAttachmentData',
    'isEmailMode', 'isAssistant', 'assistantApply', 'assistantResult', 'currentMenu'
  ],
  data() {
    return {
      commentInput: '',
      excludedEmoji: ['flags', 'objects', 'recent'],
      emojiSize: 16,
      sheetSize: 16,
      toggleEmoji: false,
      textareaStyle: {},
      emojione: (typeof emojione !== 'undefined') ? emojione : {},
      delayTyping: false,
      imageData: null,
      uploadData: [],
      uploadDataId: 0,
      maxCount: 280,
      emailAttachments: [],
      isSendingEmail: false,
    };
  },
  mounted() {
    if (!this.isAssistant) {
      window.aiAssistant.isRegistered().then((res) => {
        this.$emit('assistant-enabled', res.registered);
      });
    }
    this.textareaStyle = {
      color: this.core.UI.colors.formMessageTextColor,
    };
  },
  computed: {
    sendBtnStatus() {
      return this.commentInput.length > 0
        ? this.core.UI.colors.formMessageIconHoverColor
        : this.core.UI.colors.formMessageIconColor;
    },
    showTwitterWordCount() {
      if (!this.core.selected || !('options' in this.core.selected)) return false;
      const check = this.core.selected.options ? JSON.parse(this.core.selected.options) : {};
      return Object.keys(check).length > 0 ? JSON.parse(this.core.selected.options).channel.toLowerCase().includes('twitter') : false;
    },
    isTwitterValid() {
      return this.commentInput.length <= this.maxCount;
    },
    checkInputNotTwitter() {
      return this.commentInput.length > 0 ? 'opacity: 1; cursor: pointer' : 'opacity: 0.3; cursor: default';
    },
    checkInputIsTwitter() {
      return this.isTwitterValid && this.commentInput.length > 0 ? 'opacity: 1; cursor: pointer' : 'opacity: 0.3; cursor: default';
    },
    lastMessage() {
      if (!this.isEmailMode) return null;
      const lastCommentUser = [...this.core.selected.comments]
        .reverse()
        .filter(c => c.type === 'custom' && c.payload.type === 'email_attachment')
        .find((f) => {
          let usernameReal = f.username_real.toString();
          let userDataEmail = this.core.userData.toString();
          if (f.extras && f.extras.alternate_user) {
            usernameReal = f.extras.alternate_user.email.toString();
          }
          if (this.core.UI.alternateUser) {
            userDataEmail = this.core.UI.alternateUser.email.toString();
          }
          return (
            usernameReal !== userDataEmail
          );
        });
      return lastCommentUser;
    },
  },
  methods: {
    async assistantMenuChange(value) {
      const filtered = this.core.selected.comments.filter(el => el.type === 'text');

      // Create an async function to use await inside forEach
      const processFiltered = async () => {
        const filtering = [];
        filtered.forEach((val) => {
          if (val.user_extras !== undefined && typeof val.user_extras === 'object') {
            if (val.user_extras.type === 'customer') {
              filtering.push({
                role: 'user',
                content: val.message,
              });
            } else {
              filtering.push({
                role: 'assistant',
                content: val.message,
              });
            }
          }
        });
        return filtering;
      };

      // Call the async function
      const historyChat = await processFiltered();
      this.$emit('assistant-changes', {
        history: historyChat,
        input: this.commentInput,
        menu: value,
      });
    },
    async assistantMenuChangeOnEmail(value) {
      const filtered = this.core.selected.comments.filter(el => el.type === 'custom' && el.message !== '');

      // // Create an async function to use await inside forEach
      const processFiltered = async () => {
        const filtering = [];
        filtered.forEach(async (val) => {
          if (val.user_extras !== undefined && typeof val.user_extras === 'object') {
            const turndownService = new TurndownService();
            const textarea = document.createElement('textarea');
            textarea.innerHTML = val.message;
            const content = await turndownService.turndown(textarea.value);
            if (val.user_extras.type === 'customer') {
              filtering.push({
                role: 'user',
                content,
              });
            } else {
              filtering.push({
                role: 'assistant',
                content,
              });
            }
          }
        });
        return filtering;
      };

      // // Call the async function
      const historyChat = await processFiltered();
      this.$emit('assistant-changes', {
        history: historyChat,
        input: this.$refs.emailEditor.getContents(),
        menu: value,
      });
    },
    handlePaste(event, isAttachment = false) {
      const self = this;
      if (event.clipboardData.items.length < 1) return true;
      const item = Array.from(event.clipboardData.items)
        .find(it => it.kind === 'file');
      if (typeof (item) === 'undefined' || item === null) return true;
      if (item.type.indexOf('image') === -1) return true;
      const file = item.getAsFile();
      const fileReader = new FileReader();
      fileReader.onload = () => {
        if (!isAttachment) {
          self.setAttachmentData({
            file,
            thumbnail: fileReader.result,
          });
        } else {
          self.emailAttachments.push(file);
        }
      };
      fileReader.readAsDataURL(file);
      return true;
    },
    handleImageData(event) {
      if (event) {
        this.imageData = event.target.files;
      } else {
        this.imageData = null;
        this.$refs.inputImage.value = null;
      }
    },
    handleUploadData(data) {
      const uploadData = this.uploadData;
      if (data.id) {
        const i = uploadData.findIndex(d => d.id === data.id);
        uploadData.splice(i, 1);
      } else {
        this.uploadDataId += 1;
        uploadData.push({
          id: this.uploadDataId,
          data: data.image,
        });
      }
      this.handleImageData(null);
    },
    trySubmitComment(e) {
      if (!this.isTwitterValid && this.showTwitterWordCount) return;
      if (!e.shiftKey) {
        e.preventDefault();
        e.stopPropagation();
        // this code is needed for emoji implementation, dirty, but works, need to refine later
        const selector = '.qcw-comment-form textarea';
        const element = document.querySelector(selector);
        this.commentInput = element.value;
        let message = this.commentInput.trim();
        if (typeof emojione !== 'undefined') message = emojione.shortnameToUnicode(message);
        if (this.commentInput.trim().length < 1) return;
        this.commentInput = '';
        this.submitComment(this.core.selected.id, message);
      }
    },
    submitComment(topicId, comment) {
      const self = this;
      let extras = null;
      const nanotimestamp = (window.performance.now() + window.performance.timeOrigin);
      const uniqueId = `${topicId}_${nanotimestamp}`;
      if (self.core.UI.alternateUser) {
        extras = {
          alternate_user: self.core.UI.alternateUser,
        };
      }
      if (self.repliedComment === null) {
        self.core.sendComment(
          topicId,
          comment,
          uniqueId,
          'text',
          null,
          extras,
        ).then((res) => {
            scrollIntoLastElement(self.core);
            self.core.options.sentMessageCallback(res);
          });
      } else {
        const payload = {
          text: comment,
          replied_comment_id: self.repliedComment.id,
          replied_comment_message: self.repliedComment.message,
          replied_comment_payload: self.repliedComment.payload,
          replied_comment_sender_email: self.repliedComment.username_real,
          replied_comment_sender_username: self.repliedComment.username_as,
          replied_comment_type: self.repliedComment.type,
        };
        self.closeReplyHandler();
        self.core.sendComment(
          topicId,
          comment,
          uniqueId,
          'reply',
          JSON.stringify(payload),
          extras,
        )
          .then((res) => {
            scrollIntoLastElement(self.core);
            self.core.options.sentMessageCallback(res);
          });
      }
    },
    typingHandler(event) {
      if (!this.isEmailMode) {
        this.resizeCommentForm(event);
      }
      if (!this.delayTyping) {
        this.delayTyping = true;
        if (this.core.UI.isPublishTyping) {
          this.publishTyping(); // publish typing to mqtt
        }
        setTimeout(() => {
          this.delayTyping = false;
        }, 5000);
      }
    },
    resizeCommentForm(event) {
      const treshold = 80;
      const textarea = event.currentTarget;
      const formContainerStyle = window.getComputedStyle(textarea.parentElement);
      const pt = parseInt(formContainerStyle.paddingTop, 10);
      const pb = parseInt(formContainerStyle.paddingBottom, 10);
      textarea.style.height = '26px';
      if (textarea.scrollHeight < treshold) {
        textarea.style.height = `${textarea.scrollHeight}px`;
        textarea.style.overflowY = 'hidden';
        textarea.parentElement.style.flexBasis = `${textarea.scrollHeight + pt + pb + 2}px`;
      } else {
        textarea.style.overflowY = 'scroll';
        textarea.style.height = `${treshold}px`;
        textarea.parentElement.style.flexBasis = `${treshold + pt + pb + 2}px`;
      }
    },
    publishTyping() {
      const self = this;
      if (this.core.selected.isChannel) return;
      if (self.commentInput.length > 0) {
        self.core.realtimeAdapter.publishTyping(1);
      } else {
        self.core.realtimeAdapter.publishTyping(0);
      }
    },
    changeFile(file, caption) {
      let extras = null;
      if (this.core.UI.alternateUser) {
        extras = {
          alternate_user: this.core.UI.alternateUser,
        };
      }
      uploadFile(file, caption, this.core, this.$toasted, extras);
    },
    setEmailAttachment(e) {
      const files = e.target.files;
      this.emailAttachments.push(...files);
      e.target.value = '';
    },
    calculateSizeInMB,
    deleteAttachment(index) {
      this.emailAttachments.splice(index, 1);
    },
    clearAllMessage() {
      this.commentInput = '';
      this.emailAttachments = [];
      this.$refs.emailEditor.deleteText();
    },
    emojiParser() {
      const selector = '.qcw-comment-form textarea';
      const element = document.querySelector(selector);
      this.commentInput = element.value;
      let message = this.commentInput.trim();
      if (typeof emojione !== 'undefined') message = emojione.shortnameToUnicode(message);
      this.commentInput = '';
      return message;
    },
    async sendEmailMessage() {
      const self = this;
      let isFailedUpload = false;
      self.isSendingEmail = true;
      // eslint-disable-next-line
      for (let i = 0; i < self.emailAttachments.length; i++) {
        try {
          const file = self.emailAttachments[i];
          if (!file.url) {
            // eslint-disable-next-line
            const url = await uploadEmailAttachment(file, self.core, self.$toasted);
            self.emailAttachments[i].url = url;
          }
        } catch (error) {
          isFailedUpload = true;
          break;
        }
      }
      if (isFailedUpload) return;
      const message = self.commentInput;
      if (message.trim().length < 1 && self.emailAttachments.length === 0) return;
      let extras = null;
      if (self.core.UI.alternateUser) {
        extras = {
          alternate_user: self.core.UI.alternateUser,
        };
      }
      let files = [];
      if (self.emailAttachments.length > 0) {
        files = self.emailAttachments.map(f => ({
          file_name: f.name,
          size: f.size,
          url: f.url,
        }));
      }
      let emailData = {
        subject: '',
        cc: [],
        bcc: [],
      };
      if (this.lastMessage && this.lastMessage.payload.content.email_data) {
        emailData = { ...this.lastMessage.payload.content.email_data };
      }
      const generateTypeMessage = self.core.generateCustomMessage({
        roomId: self.core.selected.id,
        text: message,
        type: 'email_attachment',
        payload: { email_attachment: files, email_data: emailData },
        extras,
      });
      self.clearAllMessage();
      self.core.sendComment(
        generateTypeMessage.room_id,
        generateTypeMessage.message,
        generateTypeMessage.unique_id,
        generateTypeMessage.type,
        generateTypeMessage.payload,
        generateTypeMessage.extras,
      )
        .then((res) => {
          self.isSendingEmail = false;
          scrollIntoLastElement(self.core);
          self.core.options.sentMessageCallback(res);
        }).catch(() => {
          self.isSendingEmail = false;
        });
    },
    onchangeEmailForm(value) {
      this.typingHandler(null);
      const onlyText = this.cleanHtml(value);
      this.commentInput = onlyText ? value : '';
    },
    cleanHtml(textWithHtml) {
      const text = document.createElement('div');
      text.innerHTML = textWithHtml;
      return text.innerText;
    },
  },
  watch: {
    assistantApply(newValue) {
      if (newValue) {
        if (!this.isEmailMode) {
          this.commentInput = this.assistantResult;
          this.$emit('assistant-changes', {
            history: null,
            input: '',
            menu: null,
          });
          this.$emit('assistant-apply', false);
        } else {
          this.$refs.emailEditor.setText(this.assistantResult);
          this.$emit('assistant-changes', {
            history: null,
            input: '',
            menu: null,
          });
          this.$emit('assistant-apply', false);
        }
      }
    },
  },
};
</script>

<style lang="stylus">
  @import '../assets/stylus/_variables.styl'
  .backdrop-enter-active,
  .backdrop-leave-active
    -webkit-transition all 0.5s ease
    transition all 0.5s ease

  .backdrop-enter,
  .backdrop-leave-to
    opacity 0 !important

  .backdrop-enter-to,
  .backdrop-leave
    opacity 0.5 !important

  .fade-enter-active,
  .fade-leave-active
    -webkit-transition all 0.3s ease
    transition all 0.3s ease

  .fade-enter,
  .fade-leave-to
    opacity 0

  .fade-leave-active
    position absolute

  .qcw-comment-form
    display flex
    justify-content space-between
    position relative
    order 2
    transition all 0.05s ease-out
    &.email-mode
      flex-direction: column;
      .email-form-footer
        margin-top: 20px;
        display: flex
        align-items: center
        justify-content: space-between
        .container-email-button
          display: flex
          align-items: center
          gap: 10px
          margin 0px 5px;
          .send-button-email
            padding: 10px 32px
            border: none
            border-radius: 24px;
            background: #27B199;
            color: white;
            cursor: pointer
            &:disabled
              background: #B6B6B6
              cursor: not-allowed
  .container-form-msg
    border: 1px solid #C4C4C4;
    border-radius: 8px;
  .input-form
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    flex 1
    display flex
    flex-direction: row;
    border-radius: 8px;
    padding 16px 30px 16px 16px
    margin 0px 5px
    &.email-mode-input
      border: none
      padding 16px 0px;

  .qcw-comment-form textarea
    border 0
    flex 1
    font-size 14px
    font-family "Open Sans", sans-serif
    line-height 150%
    max-height 100%
    height 26px
    resize none
    &::-webkit-scrollbar-track
      border-radius: 10px;
      background-color: #fafafa;

    &::-webkit-scrollbar
      width: 0px;
      background-color: #fafafa;

    &::-webkit-scrollbar-thumb
      border-radius: 4px;
      background-color: #e0e0e0;
    &:focus
      border 0
      outline none

  .qcw-comment-form i
    display inline-block
    text-align center
    flex 0 20px
    padding 0 8px
    align-self center

    label
      cursor pointer

    input[type="file"]
      display none

    &.qcw-icon:hover svg.qc-icon
      fill $green

  .qcw-upload-toast
    position absolute
    bottom 64px
    right 10px
    z-index 2
    display flex
    flex-direction column

  .qcw-text-warning
    color #e55039 !important
</style>



// WEBPACK FOOTER //
// src/components/CommentForm.vue